import React from "react";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { achievementCategoryAddModalStore } from "../stores/achievementCategoryAddModal";
import Container from "@cloudscape-design/components/container";
import { achievementCategoryEditModalStore } from "../stores/achievementCategoryEditModal";
import FormField from "@cloudscape-design/components/form-field";
/* ------- */

class AchievementCategoryEditModal extends React.Component {
	state = { loading: false };
	editCategory() {
		this.setState({ loading: true });
		const payload = {
	    ...this.props.categoryEditModal,
			type: this.props.categoryEditModal?.type?.value,
			active: this.props.categoryEditModal?.active?.value,
		};

		this.props.Interface.request("set", {
			class: "data",
			module: "achievementCategory",
			method: "edit"
		}, { ...payload}).then((result) => {
			this.props.Interface.addNoty("Success", "Achievement category was successfully updated");
			this.props.setEditCategoryModal({ ...this.props.categoryEditModal, show: false });
			this.props.Interface.loadAchievementCategoryList();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setEditCategoryModal({ ...this.props.categoryEditModal, loaded: true, error });
			this.setState({ loading: false });
		})


	}

	render() {
		return (
			<>
				<Modal
					visible={this.props.categoryEditModal.show}
					onDismiss={() => {
						this.props.setEditCategoryModal({ ...this.props.categoryEditModal, loaded: true, show: false, name: "" });
					}}
					header="Edit category"
					children={
						<Container>
							<SpaceBetween direction="vertical" size="m">
								<FormField label="Category name" description="Translation key" stretch>
									<Input
										autoFocus="true"
										name="name"
										autoComplete="off"
										inputMode="url"
										type="text"
										disableBrowserAutocorrect={true}
										placeholder="name"
										value={this.props.categoryEditModal.name}
										onChange={(input) => {
											this.props.setEditCategoryModal({ ...this.props.categoryEditModal, name: input.detail.value });
										}}
									/>
								</FormField>
								<FormField label="Category type" description="Type of category" stretch>
									<Select
										filteringType="auto"
										placeholder="Type"
										selectedOption={this.props.categoryEditModal.type}
										onChange={(option) => {
											option.detail.selectedOption.type !== this.props.categoryEditModal.type &&
											this.props.setEditCategoryModal({ ...this.props.categoryEditModal, type: option.detail.selectedOption});
										}}
										options={this.props.categoryEditModal.currentOptions.type}
									/>
								</FormField>
								<FormField label="Active" stretch>
									<Select
										selectedOption={
											this.props.categoryEditModal.active
										}
										onChange={({ detail }) =>
											this.props.setEditCategoryModal({
												...this.props.categoryEditModal,
												active: detail.selectedOption,
											})
										}
										options={[{ value: "1", label: "Enabled" }, { value: "0", label: "Disabled" }]}
										placeholder="Select active"
									/>
								</FormField>
							</SpaceBetween>
						</Container>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													disabled={this.state.loading}
													onClick={() => {
														this.props.setEditCategoryModal({ ...this.props.categoryEditModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													loading={this.state.loading}
													disabled={this.state.loading}
													variant="primary"
													onClick={() => {
														this.editCategory();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const categoryEditModal = useRecoilValue(achievementCategoryEditModalStore);
		const setEditCategoryModal = useSetRecoilState(achievementCategoryEditModalStore);

		return <Component {...props}  categoryEditModal={categoryEditModal} setEditCategoryModal={setEditCategoryModal} />;
	};
}

export default withRecoil(AchievementCategoryEditModal);
